import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/v4/tss-react';

const useStyles = makeStyles({ name: 'CheckoutView' })(
  ({ palette, breakpoints, spacing }) => ({
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(0),
    },
    backButton: {
      alignSelf: 'flex-start',
    },
    layout: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr)',
      gridTemplateAreas: '"summary" "fields" "actions"',
      rowGap: spacing(2),
      [breakpoints.up('md')]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gridTemplateAreas: '"fields summary" "fields actions"',
        gridTemplateRows: 'auto 1fr',
        columnGap: spacing(4),
      },
    },
    summary: {
      gridArea: 'summary',
    },
    fields: {
      gridArea: 'fields',
    },
    actions: {
      gridArea: 'actions',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      alignSelf: 'start',
    },
    contact: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: spacing(0),
      padding: `${spacing(1)} ${spacing(0)}`,
      borderTop: `${pxToRem(1)} solid ${palette.semantic.border.divider}`,
    },
    contactContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(-1),
    },
    contactLink: {
      textDecoration: 'underline',
    },
  })
);

export default useStyles;
